exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-gallery-preview[data-v-665cf785]:hover{cursor:pointer}.internal-notice[data-v-665cf785]{background:rgba(0,0,0,.1);padding-top:.5rem;padding-bottom:.5rem;border-top:2px solid rgba(0,0,0,.3)}", ""]);

// exports
